
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevTag } from '@ds/components/Tag'

import ProductCardRatings from '@landing/components/ProductCardRatings/ProductCardRatings.vue'

import ColorSwatches from './ColorSwatches.vue'
import translations from './ProductCard.translations'

export default {
  components: {
    RevButtonBase,
    RevCard,
    RevIllustration,
    RevTag,
    ColorSwatches,
    ProductCardRatings,
  },
  props: {
    description: { type: String, default: undefined },
    imageAlt: { type: String, required: true },
    imageSrc: { type: String, required: true },
    link: { type: Object, required: true },
    price: { type: Object, required: true },
    priceWhenNew: { type: Object, default: () => undefined },
    colorSwatches: { type: Array, default: () => [] },
    reviewRating: { type: Object, required: false, default: undefined },
    tag: { type: String, default: undefined },
    title: { type: String, required: true },
    warranty: { type: String, default: undefined },
  },
  computed: {
    translations: () => translations,
  },
}
